import React from 'react'
import Slider from 'lib/ui/Slider'
import {Controller, UseFormMethods} from 'react-hook-form'
import {Label} from 'lib/ui/typography'
import FontSelect from 'lib/FontSelect'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import {CAPS} from 'lib/ui/typography/FontStyleInput'
import {WidgetCalendar} from 'organization/Event/WidgetConfig/ButtonStylesConfig/WidgetCalendar'

const DEFAULT_FONT_SIZE = 16

export default function TitleTypographySection(props: {
  control: UseFormMethods['control']
  button: WidgetCalendar
  storageKey: string
  label: string
}) {
  const {control, button, label} = props

  return (
    <CollapsibleSection label={label} storageKey={props.storageKey}>
      <Label>Font</Label>
      <Controller
        control={control}
        name="titleFont"
        defaultValue={{
          family: button.titleFont?.family || 'inherit',
          variants: button.titleFont?.variants || [],
          styles: button.titleFont?.styles || [CAPS],
        }}
        render={({value, onChange}) => (
          <FontSelect value={value} onChange={onChange} />
        )}
      />
      <Controller
        name="titleFontSize"
        defaultValue={button.titleFontSize || DEFAULT_FONT_SIZE}
        control={control}
        render={({value, onChange}) => (
          <Slider
            min={1}
            max={100}
            onChange={onChange}
            valueLabelDisplay="off"
            value={value}
            label="Font Size"
          />
        )}
      />
    </CollapsibleSection>
  )
}
